module.exports = __webpack_public_path__ + "static/media/kayden-kross-lesb.217c7299.jpg";